<div class="row">
  <div class="col-lg-6 mt-4">
    <h3>Bulk User Upload</h3>
  </div>
</div>
<div>
  <table class="table table-striped">
    <tbody>
      <tr>
        <th class="col-xs-3">
          Upload user spreadsheet
        </th>
        @if (userProcessing) {
          <td class="text-success">
            You will be notified by email when the users have been created.
          </td>
        }
        @if (!userProcessing) {
          <td>
            <div class="input-group">
              <input type="file"
                class="form-control"
                (change)="userFileChangeEvent($event.target.files)" />
            </div>
            @if (errorMessage) {
              <div class="error">
                {{ errorMessage }}
              </div>
            }
          </td>
        }
      </tr>
    </tbody>
  </table>
  <div class="d-flex justify-content-end">
    <button class="btn btn-primary" (click)="onSaveClick()" [disabled]="disableSave">
      Upload
    </button>
  </div>
</div>